import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';

import Money from '../../../common/money';
import Time from '../../../common/Time';
import Date from '../../../common/date';

const ActiveRegister = ({ transactions }) => (
  <ReactTable
    className="c-table c-table-new c-no-hover c-table--small ReactTable--sticky-header c-cash-register-table"
    data={transactions}
    noDataText="There are no transactions currently"
    defaultPageSize={20}
    minRows={0}
    pageText=""
    showPageSizeOptions={false}
    columns={[{
      Header: 'Created at',
      accessor: 'createdAt',
      maxWidth: 220,
      Cell: row => (
        <span className="o-flexbox">
          <span className="u-mr-"><Date>{row.value}</Date></span>
          <Time>{row.value}</Time>
        </span>
      ),
    }, {
      Header: 'Description',
      accessor: 'desc',
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      maxWidth: 120,
      Cell: row => <Money cents={row.value} />,
    }]}
    defaultSorted={[
      {
        id: 'createdAt',
        desc: true,
      },
    ]}
    getProps={() => ({
      'data-automation-id': 'container:activeRegisterRecords',
    })}
  />
);

ActiveRegister.propTypes = {
  transactions: PropTypes.arrayOf(PropTypes.object),
  hasActiveRegister: PropTypes.bool.isRequired,
};

ActiveRegister.defaultProps = {
  transactions: [],
  timezone: '',
};

export default ActiveRegister;
